// components.
import { AnalyticsBrokers } from "./components/AnalyticsBrokers";
import { RowsBrokers } from "./components/RowsBrokers";

export const TableBrokers = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 165px)",
        overflowY: "auto",
      }}
    >
      <AnalyticsBrokers />
      <RowsBrokers />
    </div>
  );
};
